import absoluteUrl from 'next-absolute-url'

import PrivacyPolicyFixer from 'containers/PrivacyPolicyFixer'

import Layout from 'components/Layout'
import MetaTags from 'components/MetaTags'

import { data } from 'constant/term-legal-policy'

export default function Index({ canonical }) {
  const title =
    data?.privacyPolicyFixer?.title ||
    'นโยบายคุ้มครองข้อมูลส่วนบุคคลสำหรับผู้ให้บริการบนแอปพลิเคชันวูล์ฟ (Privacy Policy)'
  const metaTitle = `24FIX | ${title}`
  const metaDescription = `24FIX | ${title}`

  return (
    <>
      <MetaTags title={metaTitle} description={metaDescription} pathUrl={canonical} />
      <Layout>
        <PrivacyPolicyFixer data={data} />
      </Layout>
    </>
  )
}

export async function getServerSideProps(context) {
  const { req } = context
  const { origin } = absoluteUrl(req)

  return {
    props: JSON.parse(
      JSON.stringify({
        canonical: `${origin}/wolf/privacy-policy`,
      })
    ),
  }
}
